/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Icon } from '@components/atoms'
import { DragLayerMonitorProps } from '@minoru/react-dnd-treeview'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	monitorProps: DragLayerMonitorProps<any>
}

/** 드래그 중 따라오는 라벨 — ink 바탕, radius 2 */
export const NodeDragPreview: React.FC<PropsType> = props => {
	const item = props.monitorProps.item

	return (
		<View css={style}>
			<Icon name="drag-horizontal-variant" className="draggedHandleIcon" />
			{item.text}
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	gap: 6,
	width: 'fit-content',
	marginTop: '-1.2rem',
	marginLeft: '-1rem',
	padding: '6px 10px',
	backgroundColor: mono.ink,
	borderRadius: 2,
	color: '#FFFFFF',
	fontFamily: boFont.ui,
	fontSize: 12,
	fontWeight: 500,
	pointerEvents: 'none',

	'.draggedHandleIcon': {
		fontSize: 14,
		color: '#FFFFFF',
	},
})
